import { navigate } from 'gatsby';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { MenuItem } from '../MenuUtils';

interface MenuLinkProps {
  item: MenuItem;
  onClick?: () => void;
  className?: string;
  closeMenu: () => void;
}

export const MenuLink: FunctionComponent<MenuLinkProps> = ({ item, onClick, closeMenu, children, className }) => {
  const onClickLocal = (e: any) => {
    e.preventDefault();
    onClick && onClick();
  };
  const hasChildren = item.hideChildren ? false : item.children && item.children.length > 0;

  // If item has children, we don't go anywhere but instead call the passed onClick()
  if (hasChildren && onClick != undefined) {
    return (
      <Styleda className={'a ' + (className ? className : '')} onClick={onClickLocal}>
        {children}
      </Styleda>
    );
  }

  const onInternalLinkClick = (href: string) => {
    closeMenu();
    navigate(href);
  };

  // For internal links to Gatsby page, if where are not in SHARED_COMPONENT_MODE we can use optimized Gatsby navigate function
  // note: tryed to use <Link> instead but using its onClick gave unattended result (full page loading)
  const href = item.href;
  if (!item.external && href && !process.env.SHARED_COMPONENT_MODE) {
    return (
      <LinkSpan
        className={'a ' + (className ? className : '')}
        onClick={() => {
          onInternalLinkClick(href);
          onClick && onClick();
        }}
      >
        {children}
      </LinkSpan>
    );
  }

  return (
    <Styleda className={'a ' + (className ? className : '')} href={item.href} target={item.targetBlank ? '_blank' : undefined} onClick={onClick}>
      {children}
    </Styleda>
  );
};

const LinkSpan = styled.span`
  font-size: 14px;
  cursor: pointer;
  &:hover {
    color: #ff0b75;
  }
  transition: color 0.2s ease-in-out;
`;

const Styleda = styled.a`
  font-size: 14px;
  cursor: pointer;
  &:hover {
    color: #ff0b75;
  }
  transition: color 0.2s ease-in-out;
`;
